import React from 'react';

export function workingHoursAndMinutes(seconds){
    const hours = Math.floor(seconds/3600);
    const minutes = Math.round((seconds - hours * 3600) / 60);
    if(hours === 0){
        return(
            <span>{minutes}min</span>
        );
    }
    return(
        <span>{hours}h {minutes}min</span>
    )
}

export function workingHours(seconds){
    return Math.round(seconds/36)/100;
}



// WEBPACK FOOTER //
// ./src/scenes/Clock/helpers.js